import { useQuery } from "react-query"
import { get_job_seeker_licenses } from "../../../services/approvals";


const useJobSeekerLicenses = (id) => {
    return useQuery('get_job_seeker_licenses', ()=> get_job_seeker_licenses(id))
}

export default useJobSeekerLicenses;